import React, { useEffect, useState } from 'react';

/**
 * Avatar that renders directly from a full public URL (Celeb Room APIs return
 * ready-to-use profile_photo_url / profile_photo values). Falls back to an
 * initial letter when the URL is empty or fails to load.
 *
 * @param {{ url?: string, name?: string, size?: number, className?: string }} props
 */
export default function UrlAvatar({ url, name = '', size = 40, className = '' }) {
  const [broken, setBroken] = useState(false);
  useEffect(() => {
    setBroken(false);
  }, [url]);

  const initial = (typeof name === 'string' && name.trim() ? name.trim()[0] : '?').toUpperCase();
  const dim = { width: size, height: size };

  if (!url || broken) {
    return (
      <span className="inline-flex shrink-0 leading-none">
        <div
          className={`rounded-full bg-dark-surface border border-dark-border flex items-center justify-center text-dark-text-secondary font-medium shrink-0 ${className}`}
          style={{ ...dim, fontSize: Math.max(10, Math.round(size * 0.35)) }}
          aria-hidden
        >
          {initial}
        </div>
      </span>
    );
  }

  return (
    <span className="inline-flex shrink-0 leading-none">
      <img
        src={url}
        alt=""
        className={`rounded-full object-cover border border-dark-border shrink-0 block ${className}`}
        style={dim}
        onError={() => setBroken(true)}
      />
    </span>
  );
}
